export default __webpack_public_path__ + "static/media/space.e4a973ea.gif";